import { NavLink } from 'react-router-dom';
import { useFetch } from '../lib/useFetch';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';
import { isNativeApp } from '../lib/push';
import { TabGlyph } from './AppIcons';

type Tab = { to: string; label: string; icon: Parameters<typeof TabGlyph>[0]['kind'] };

export function TabBar() {
  // Підтягуємо аватарку, щоб у вкладці "Профіль" показати фото з Telegram замість emoji
  const { data } = useFetch(() => api.me(), []);
  const photoUrl = data?.user.photoUrl ?? null;
  const isPremium = data?.user.isPremium ?? false;

  // У нативній Android-апці ховаємо «Битви» — вони соц-фіча через Telegram.
  const native = isNativeApp();
  const tabs: Tab[] = [
    { to: '/', label: 'Головна', icon: 'home' },
    { to: '/categories', label: 'Тести', icon: 'tests' },
    ...(native ? [] : [{ to: '/battles', label: 'Битви', icon: 'battle' } as Tab]),
    { to: '/premium', label: 'Premium', icon: 'crown' },
    { to: '/profile', label: 'Профіль', icon: 'profile' },
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 z-10 border-t border-tg-secondary-bg bg-tg-bg pb-[env(safe-area-inset-bottom)]">
      <div
        className={`mx-auto grid max-w-screen-sm ${native ? 'grid-cols-4' : 'grid-cols-5'}`}
      >
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            onClick={() => haptic.selection()}
            end={t.to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2 text-xs ${
                isActive ? 'text-tg-link' : 'text-tg-hint'
              }`
            }
          >
            <span className="relative grid h-6 w-6 place-items-center leading-none">
              {t.to === '/profile' && photoUrl ? (
                <img
                  src={photoUrl}
                  alt=""
                  className={`h-6 w-6 rounded-full object-cover ${
                    isPremium ? 'ring-2 ring-yellow-500' : ''
                  }`}
                />
              ) : (
                <TabGlyph kind={t.icon} className="h-[22px] w-[22px]" />
              )}
            </span>
            <span>{t.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
